import { useCallback, useEffect, useState } from 'react'
import AIService from '../services/aiService'
import { errorMessage } from '../services/axios/errorMessage'

/**
 * Whether the AI tools can run, for pages that need the model. The key
 * check always runs (there is no demo mode that skipped it).
 *
 * - Key configured: ready. Not configured: 'missing'.
 * - The check itself failed (on dev it 500s): 'error' with the reason. It
 *   used to read as "API key not configured", which sent people to Settings
 *   to fix a key that was not the problem.
 *
 * @returns {{state: 'checking'|'ready'|'missing'|'error', reason: string, retry: () => void}}
 */
const useAiStatus = () => {
    const [status, setStatus] = useState({ state: 'checking', reason: '' })

    const check = useCallback(() => {
        setStatus({ state: 'checking', reason: '' })
        AIService.getStatus()
            .then((res) =>
                setStatus({
                    state: res.data?.configured ? 'ready' : 'missing',
                    reason: '',
                })
            )
            .catch((err) =>
                setStatus({
                    state: 'error',
                    reason: errorMessage(err?.response),
                })
            )
    }, [])

    useEffect(() => {
        check()
    }, [check])

    return { ...status, retry: check }
}

export default useAiStatus
